import { OpenAPIObject, PathsObject, ReferenceObject, SchemaObject } from 'openapi3-ts';
import { OpenApiZodAny, extendApi as originalExtendApi } from '@anatine/zod-openapi';
import { cloneZod } from './utils/any';

// Accepts a RedocSchemaObject that is an extension of the OpenAPIObject and clone the Zod schema
export function extendApi<T extends OpenApiZodAny>(schema: T, schemaObject?: RedocSchemaObject): T {
  return originalExtendApi(cloneZod(schema), schemaObject);
}

export interface RedocOpenAPIObject extends OpenAPIObject {
  'x-tagGroups': RedocTagGroup;
  'x-webhooks'?: PathsObject;
}

export interface RedocSchemaObject extends SchemaObject {
  tags?: string[];
  $ref?: string;
  additionalProperties?: RedocAdditionalProperties;
  'x-extendedDiscriminator'?: string;
}

export type RedocAdditionalProperties =
  | (SchemaObject & {
      'x-additionalPropertiesName'?: string;
    })
  | ReferenceObject
  | boolean;

export interface RedocTagGroup {
  name: string;
  tags: string[];
}
